import mapGeneralProduct, { RawProduct as RawGeneralProduct } from '~/Api/Product/mapProduct';

import { mapReferencePrice, RawReferencePrice } from './mapReferencePrice';
import { Product } from './Product';

export interface RawProduct {
	readonly product: RawGeneralProduct;
	readonly referencePrices: RawReferencePrice[];
	readonly fxComparisonReferencePrice: RawReferencePrice | null;
	readonly packageSizeForCalculation: number | null;
	readonly packageSizeForSingleUnit: number | null;
	readonly singleUnitPackageSize: boolean;
	readonly selected: boolean;
	readonly selectable: boolean;
	readonly referenceDataSource: boolean;
	readonly fxComparisonResolution: string;
}

export function mapProduct(product: RawProduct): Product {
	return new Product(
		mapGeneralProduct(product.product),
		product.referencePrices.map(mapReferencePrice),
		product.fxComparisonReferencePrice ? mapReferencePrice(product.fxComparisonReferencePrice) : null,
		product.packageSizeForCalculation,
		product.packageSizeForSingleUnit,
		product.singleUnitPackageSize,
		product.selected,
		product.selectable,
		product.referenceDataSource,
		product.fxComparisonResolution
	);
}
